/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import {
  Text,
  RichText,
  withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import compose from 'lodash/fp/compose';
import { withNamespaces } from 'react-i18next';
import get from 'lodash/get';
import { fieldHasValue } from '../../../../utils/sitecore';
import DotComponent from '../../../ui/DotComponent';
import CtaLink from '../../../ui/CtaLink';
import { arrows } from '../../../ui/CtaLink/types';
import { Column, Row } from '../../../../styles/Grid';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import {
  bodyDescriptionCss,
  headlineCss,
  headerCss,
  anchorCss,
} from './index.styles';

class SolutionsCardsHeader extends SafePureComponent {
  safeRender() {
    const { headline, description, cta, sitecoreContext } = this.props;
    const headlineHasText = fieldHasValue(headline);
    const descriptionHasText = fieldHasValue(description);
    const isLink = !!get(cta, 'value.href', '');
    const isEditing = get(sitecoreContext, 'pageEditing', true);
    const headlineShouldRender = isEditing || headlineHasText;
    const descriptionShouldRender = isEditing || descriptionHasText;
    const ctaShouldRender = isEditing || isLink;
    return (
      <Row css={headerCss}>
        <Column cols={{ sm: 6, md: 8, lg: 10 }}>
          {headlineShouldRender && (
            <h2 css={headlineCss}>
              <Text field={headline} />
              <DotComponent />
            </h2>
          )}
        </Column>
        <Column cols={{ sm: 6, md: 8, lg: 10 }}>
          {descriptionShouldRender && (
            <RichText css={bodyDescriptionCss} field={description} />
          )}
          {ctaShouldRender && (
            <CtaLink linkCustomCss={anchorCss} arrow={arrows.right} cta={cta} />
          )}
        </Column>
      </Row>
    );
  }
}

const defaultCta = {
  value: {
    href: '#',
    linktype: 'internal',
    text: 'Learn more about our office space default',
    anchor: '',
    querystring: '',
    target: '',
    id: '',
  },
};

SolutionsCardsHeader.defaultProps = {
  headline: '',
  description: '',
  cta: defaultCta,
};

SolutionsCardsHeader.propTypes = {
  headline: PropTypes.shape({
    value: PropTypes.string,
  }),
  description: PropTypes.shape({
    value: PropTypes.string,
  }),
  cta: PropTypes.shape({
    value: PropTypes.shape({
      href: PropTypes.string,
      linktype: PropTypes.string,
      text: PropTypes.string,
      anchor: PropTypes.string,
      querystring: PropTypes.string,
      target: PropTypes.string,
      id: PropTypes.string,
    }),
  }),
};

SolutionsCardsHeader.displayName = 'SolutionsCardsHeader';

export default compose(
  withSitecoreContext(),
  withNamespaces(),
)(SolutionsCardsHeader);
